/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowUpTail = createReactComponent("outline", "arrow-up-tail", "IconArrowUpTail", [["path", { "d": "M12 18l0 -15", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M15 21l-3 -3l-3 3", "key": "svg-2" }]]);

export { IconArrowUpTail as default };
//# sourceMappingURL=IconArrowUpTail.mjs.map
